import __request__ from "routing/request";
export function listDataAdapters(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/overrides", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setOverridesForDataAdapter(dataAdapterId, overrides, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.illuminate/overrides/${dataAdapterId}`, overrides, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getOverridesForAdapter(dataAdapterId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.illuminate/overrides/${dataAdapterId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
